declare const siteVars: { ajaxUrl: string };

const btn  = document.getElementById('ps-news-load-more') as HTMLButtonElement | null;
const grid = document.getElementById('ps-news-grid') as HTMLElement | null;

if (btn && grid) {
    btn.addEventListener('click', async () => {
        const offset  = parseInt(btn.dataset.offset   ?? '3', 10);
        const perPage = parseInt(btn.dataset.perPage  ?? '3', 10);
        const nonce   = btn.dataset.nonce ?? '';

        btn.disabled    = true;
        btn.textContent = '...';

        try {
            const body = new URLSearchParams({
                action:   'ps_load_more_news',
                nonce,
                offset:   String(offset),
                per_page: String(perPage),
            });

            const res  = await fetch(siteVars.ajaxUrl, {
                method:  'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body:    body.toString(),
            });

            const data = await res.json();

            if (data.success) {
                grid.insertAdjacentHTML('beforeend', data.data.html);
                btn.dataset.offset = String(data.data.offset);

                if (!data.data.has_more) {
                    btn.parentElement?.remove();
                } else {
                    btn.disabled    = false;
                    btn.textContent = 'VEJA MAIS';
                }
            } else {
                btn.disabled    = false;
                btn.textContent = 'VEJA MAIS';
            }
        } catch {
            btn.disabled    = false;
            btn.textContent = 'VEJA MAIS';
        }
    });
}
